import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
import { workflowSteps } from '../data/content';
const stages = ['ASSESS', 'CLASSIFY', 'EVALUATE', 'PLAN', 'DOCUMENT'];
export function WorkflowExample() {
  return <section className="w-full bg-white px-5 py-16 md:px-8 md:py-24" data-id="element-334" data-mp="fmmwi12dm05b">
      <div className="mx-auto max-w-4xl" data-id="element-335" data-mp="kgr5epv7ci91">
        <h2 className="text-center font-serif text-[1.85rem] font-extrabold leading-tight text-navy-900 sm:text-4xl md:text-5xl" data-id="element-336" data-mp="ogt7h04undou">
          See how the blueprint fits into a real clinical workflow
        </h2>
        <p className="mt-4 text-center text-lg font-bold text-gold-600" data-id="element-337" data-mp="yf8q0ept9emq">One case. One organized assessment pathway.</p>
        <p className="mx-auto mt-6 max-w-2xl text-center text-lg leading-relaxed text-ink" data-id="element-338" data-mp="13ebvu1dm7ovr">
          Imagine a patient returns with concerns about a fractured veneer and discomfort during
          function. Instead of starting with an assumed corrective procedure, the professional begins
          by organizing the available information.
        </p>

        <ol className="mt-12 space-y-5" data-id="element-339" data-mp="1a7cdbmw951o1">
          {workflowSteps.map((s, i) => <li key={s.label} className="flex gap-4 rounded-2xl bg-ivory p-5 sm:gap-6 sm:p-7" data-id="element-340" data-mp="15dhs2f100emu" data-mpi={i}>
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy-900 font-serif text-lg font-bold text-gold-300" data-id="element-341" data-mp="10fzj4omzdzeu">
                {i + 1}
              </span>
              <div data-id="element-342" data-mp="1t3lxmrxqyogh">
                <h3 className="text-lg font-extrabold text-navy-900" data-id="element-343" data-mp="1t213h3fch7j5">{s.label}</h3>
                <p className="mt-1 text-base font-semibold text-gold-600" data-id="element-344" data-mp="1o37p78s8hchx">{s.tool}</p>
                <p className="mt-2 text-base leading-relaxed text-muted" data-id="element-345" data-mp="1j4mqjdsmr0vl">{s.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12 rounded-3xl bg-navy-900 p-6 text-center text-white sm:p-10" data-id="element-346" data-mp="7qso3zmqjryc">
          <p className="font-serif text-2xl font-bold text-gold-300" data-id="element-347" data-mp="3pgulj0qqmkv">The result?</p>
          <p className="mt-3 text-lg" data-id="element-348" data-mp="3rtlwmse29al">A professional case record that follows five defined stages:</p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-349" data-mp="54ry2ab463c4">
            {stages.map((st, i) => <React.Fragment key={st} data-id="element-350" data-mp="3re2u7yv0g7dx" data-mpi={i}>
                <span className="rounded-lg bg-gold-400 px-3 py-2 text-sm font-extrabold text-navy-900 sm:text-base" data-id="element-351" data-mp="3rdb0ktkz4jqa">{st}</span>
                {i < stages.length - 1 && <ArrowRightIcon className="h-4 w-4 text-gold-300" aria-hidden="true" data-id="element-352" data-mp="3ilsk0hk481wo" />}
              </React.Fragment>)}
          </div>
          <p className="mt-6 text-sm leading-relaxed text-navy-100" data-id="element-353" data-mp="3ndsgg00z8coi">
            The framework supports organization and documentation. The clinician remains responsible
            for examination, diagnosis, treatment selection, and patient care.
          </p>
        </div>

        <SectionCTA label="Organize My Next Case This Way" data-id="element-354" data-mp="2znpr3rog5ktl" />
      </div>
    </section>;
}